import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "Slices/authSlice";
import { canAccessPath } from "utils/accessControl";

const PrivateRoute = ({ element }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, checking, checked } = useSelector((state) => state.auth);

  useEffect(() => {
    // On first load, pull the session from the httpOnly cookie so users
    // stay logged in across reloads.
    if (!checked && !checking) {
      dispatch(fetchCurrentUser());
    }
  }, [checked, checking, dispatch]);

  // Wait for the cookie-based session lookup before deciding access.
  if (checking || !checked) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Authenticating, please wait...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (!canAccessPath(location.pathname, user)) {
    return <Navigate to="/cms" replace />;
  }

  return element;
};

export default PrivateRoute;
